import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

// Searches as you type (debounced), on Enter and on clear — no separate search button to hit.
const SEARCH_DELAY = 400;

const SearchBarComp = ({ handleSearch }) => {
  const { t } = useTranslation("dashboard");
  const timer = useRef();
  const last = useRef("");

  useEffect(() => () => clearTimeout(timer.current), []);

  const run = value => {
    clearTimeout(timer.current);
    if (value === last.current) return;
    last.current = value;
    handleSearch(value);
  };

  return (
    <Input
      className="input-search ds-search"
      type="search"
      enterKeyHint="search"
      allowClear
      size="large"
      prefix={<SearchOutlined aria-hidden="true" />}
      placeholder={t("Search")}
      aria-label={t("Search")}
      onPressEnter={e => run(e.target.value)}
      onChange={e => {
        const { value } = e.target;
        clearTimeout(timer.current);
        // The clear button fires onChange with "" — search right away.
        if (!value) run("");
        else timer.current = setTimeout(() => run(value), SEARCH_DELAY);
      }}
    />
  );
};

export default SearchBarComp;
